import React from "react";
import ReactLoading from 'react-loading';

const Loading = () => {
    return (
        <div className="flex items-center justify-center h-screen bg-[#13455a]">
            <div className="flex flex-col items-center">
                <ReactLoading type={"spin"} color={"#FFF"} height={'20%'} width={'20%'} />
                <h1 className="text-[#ffffff] text-lg mt-2">Chargement en cours...</h1>
            </div>
        </div>
    );
}

export default Loading;